export const HEADER_HEIGHT = 64;
export const SUBNAV_HEIGHT = 44;
export const TERTIARY_HEIGHT = 36;

export function isPathActive(pathname, path) {
  if (!path) return false;
  if (path === '/') return pathname === '/';
  return pathname === path || pathname.startsWith(`${path}/`);
}

function pickActive(items, pathname) {
  const matches = (items || []).filter((item) =>
    item.isRoot ? pathname === item.path : isPathActive(pathname, item.path)
  );
  return matches.sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0))[0] || null;
}

export function getActiveModule(tabs, pathname) {
  return (tabs || []).find((tab) => !tab.link && isPathActive(pathname, tab.path)) || null;
}

export function getNavLayers(tabs, pathname) {
  const module = getActiveModule(tabs, pathname);
  const secondary = module?.subData?.length
    ? [{ name: module.rootNavName || module.name, path: module.path, isRoot: true }, ...module.subData]
    : [];
  const activeSecondary = pickActive(secondary, pathname);
  const tertiary = activeSecondary?.subData || [];
  const activeTertiary = pickActive(tertiary, pathname);
  const chromeHeight =
    HEADER_HEIGHT +
    (secondary.length ? SUBNAV_HEIGHT : 0) +
    (tertiary.length ? TERTIARY_HEIGHT : 0);
  return { module, secondary, tertiary, activeSecondary, activeTertiary, chromeHeight };
}

export function pathForItem(item) {
  if (item?.subData?.length) return item.subData[0].path;
  return item?.path;
}
